import Service from '../../../publish-project-service.js';

export default {
  data() {
    return {
      assigneeCodeText: '企业名称',
      placeholder: '请输入企业名称',
      assigneeForm: {
        type: 2,
        code: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择受让人类型', trigger: 'change' }
        ],
        code: [
          { required: true, validator: this.validateCode, trigger: 'blur' }
        ]
      },
      personResForm: null,
      companyForm: null
    };
  },
  watch: {
    'assigneeForm.type': function (val) {

      // 清除校验
      this.$refs.assigneeForm && this.$refs.assigneeForm.clearValidate();

      this.assigneeForm.code = '';
      this.personResForm = null;
      this.companyForm = null;
      if (Number(val) === 1) {
        this.assigneeCodeText = '受让人证件号';
        this.placeholder = '请输入受让人证件号';
      } else {
        this.assigneeCodeText = '企业名称';
        this.placeholder = '请输入企业名称';
      }
    }
  },
  methods: {
    validateCode(rule, value, callback) {
      if (!value) {
        callback(new Error(this.placeholder));
      } else {
        callback();
      }
    },
    // 查询
    serarchUserInfoByCode () {
      this.personResForm = null;
      this.companyForm = null;
      this.$refs['assigneeForm'].validate((valid) => {
        if (valid) {
          Service.getUserInfoByIdCard(this.assigneeForm).then(({ code, data }) => {
            if (code === '0' && data) {
              this.personResForm = data.personResForm;
              this.companyForm = data.companyForm;
            }
          });
        }
      });
    },
    // 确认
    confirm () {
      let assigneeInfo = null;
      // 个人
      if (this.personResForm) {
        assigneeInfo = {
          transfereeId: this.personResForm.userId,
          transfereeName: this.personResForm.name,
          transfereeType: this.assigneeForm.type
        };
      }
      // 企业
      if (this.companyForm) {
        assigneeInfo = {
          transfereeId: this.companyForm.userId,
          transfereeName: this.companyForm.companyName,
          transfereeType: this.assigneeForm.type
        };
      }
      this.$emit('changeAssigneeInfo', assigneeInfo, this.personResForm, this.companyForm);
    }
  }
};
